/**
 * Shared date/time formatting for Google Sheets gviz values (same as live class schedule).
 */

/** YYYY-MM-DD prefix for lexicographic range filters (handles ISO strings with time tails). */
export function comparableScheduleDateKey(iso) {
  if (iso === undefined || iso === null || iso === '') return '';
  const s = String(iso).trim();
  const m = /^(\d{4}-\d{2}-\d{2})/.exec(s);
  return m ? m[1] : '';
}

function parseGoogleDate(str) {
  let m = /^Date\((\d+),(\d+),(\d+),(\d+),(\d+),(\d+)\)$/.exec(str);
  if (m) {
    return new Date(Number(m[1]), Number(m[2]), Number(m[3]), Number(m[4]), Number(m[5]), Number(m[6]));
  }
  m = /^Date\((\d+),(\d+),(\d+)\)$/.exec(str);
  if (m) {
    return new Date(Number(m[1]), Number(m[2]), Number(m[3]));
  }
  return null;
}

export function formatDate(dateString) {
  try {
    let date;
    if (typeof dateString === 'string') {
      const parsed = parseGoogleDate(dateString);
      if (parsed) {
        date = parsed;
      } else {
        date = new Date(dateString);
      }
    } else {
      date = dateString;
    }

    if (!(date instanceof Date) || isNaN(date)) {
      return dateString || 'N/A';
    }
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    const weekday = date.toLocaleString('default', { weekday: 'long' });
    return `${day} ${month} ${year}, ${weekday}`;
  } catch (error) {
    return dateString || 'N/A';
  }
}

export function formatTime(timeString) {
  try {
    let date;
    if (typeof timeString === 'string') {
      const parsed = parseGoogleDate(timeString);
      if (parsed) {
        date = parsed;
      } else {
        date = new Date(timeString);
      }
    } else {
      date = timeString;
    }

    if (!(date instanceof Date) || isNaN(date)) {
      return timeString || 'TBD';
    }

    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit'
    });
  } catch (error) {
    return timeString || 'TBD';
  }
}
